import actionStateFilter from 'app/filters/actionState'

export default class ActionState {

    static PENDING = 'PENDING';
    static IN_PROCESS = 'IN_PROCESS';
    static RESOLVED = 'RESOLVED';
    static CLOSED = 'CLOSED';
    static ON_HOLD = 'ON_HOLD';
    static ACTION_PL = 'ACTION_PL';

    static options(){

        return {
            'PENDING': actionStateFilter(ActionState.PENDING),
            'IN_PROCESS': actionStateFilter(ActionState.IN_PROCESS),
            'RESOLVED': actionStateFilter(ActionState.RESOLVED),
            'CLOSED': actionStateFilter(ActionState.CLOSED),
            'ON_HOLD': actionStateFilter(ActionState.ON_HOLD),
            'ACTION_PL': actionStateFilter(ActionState.ACTION_PL)
        };
    }
}